import React, { useState } from 'react';
import Header from '../Header/Header';
import { useTheme } from "../../ui/src/contextProviders";
import { customStyle } from '@custom/Utils/utils';
import { useNavigate } from 'react-router-dom';
import BillingPackage from './billingPackage';
import ConsultationCharges from '@custom/ConsultationCharges';
import GeneralSettings from './GeneralSettings';
import Urgency from '@custom/Urgency';
import DoctorDiscount from './doctorDiscount/DoctorDiscount';
import Pricing from '@custom/Pricing';
import Investigation from '@custom/Investigation';
import './index.css';
import ReportAnalytics from './Analytics';

const Billing = () => {
  const { isDarkMode } = useTheme();
  const [activeTab, setActiveTab] = useState('general');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'packageCreation':
        return <BillingPackage activeTab={activeTab} setActiveTab={setActiveTab} />;
      case 'general':
        return <GeneralSettings />;
      case 'reporting':
        return <ReportAnalytics />;
      case 'consultationCharges':
        return <ConsultationCharges activeTab={activeTab} setActiveTab={setActiveTab} />;
      case 'urgency':
        return <Urgency activeTab={activeTab} setActiveTab={setActiveTab} />;
      case 'doctorDiscount':
        return <DoctorDiscount activeTab={activeTab} />;
      case 'pricing':
        return <Pricing activeTab={activeTab} setActiveTab={setActiveTab} />;
      case 'investigation':
        return <Investigation activeTab={activeTab} setActiveTab={setActiveTab} />;
      default:
        return <GeneralSettings />;
    }
  };

  return (
    <div className='page page__full' style={
      isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
    }>
      <div className='sticky-header'>
        <Header
          isBack={false}
          title={
            activeTab === 'packageCreation' ? 'Package Creation' :
              activeTab === 'general' ? 'General Settings' :
                activeTab === 'reporting' ? 'Reporting & Analytics Content' :
                  activeTab === 'consultationCharges' ? 'Consultation Charges' :
                    activeTab === 'urgency' ? 'Urgency Charges' :
                      activeTab === 'doctorDiscount' ? 'Referral Doctor Discount' :
                        activeTab === 'pricing' ? 'Modality Pricing' :
                          activeTab === 'investigation' ? 'Investigation Pricing' :
                            'Billings'
          }
        />
        <div className={`tabs ${isDarkMode ? 'dark-theme' : ''}`}>
          <div className={`tabs__list ${isDarkMode ? 'dark-theme' : ''}`}>
            {[
              { tab: 'general', label: 'General Settings' },
              { tab: 'packageCreation', label: 'Package Creation' },
              { tab: 'consultationCharges', label: 'Consultation Charges' },
              { tab: 'urgency', label: 'Urgency Charges' },
              { tab: 'doctorDiscount', label: 'Referral Doctor Discount' },
              { tab: 'pricing', label: 'Modality Pricing' },
              { tab: 'investigation', label: 'Investigation Pricing' },
              { tab: 'reporting', label: 'Reporting & Analytics' },
            ].map(({ tab, label }) => (
              <div
                key={tab}
                className={`tabs__item ${activeTab === tab ? 'active' : ''}`}
                onClick={() => handleTabClick(tab)}
              >
                {label}
              </div>
            ))}
          </div>
        </div>
      </div>
      {renderContent()}
    </div>
  );
};

export default Billing;
